import React from 'react';
import { useNavigate } from 'react-router-dom';

const AdminDashboardScreen = () => {
  const navigate = useNavigate();

  const adminTools = [
    { id: 'view-report', title: 'View Report', path: '/admin/reports' },
    { id: 'view-transactions', title: 'View Transactions', path: '/admin/transactions' },
    { id: 'add-transaction', title: 'Add Transaction', path: '/admin/add-transaction' },
    { id: 'add-exchange-rates', title: 'Add Exchange Rates', path: '/admin/exchange-rates' },
    { id: 'add-bitcoins', title: 'Add Bitcoins', path: '/admin/bitcoins' },
    { id: 'manage-accounts', title: 'Manage Account', path: '/admin/manage-accounts' }
  ];

  const handleLogout = () => {
    localStorage.removeItem('is_admin');
    navigate('/admin');
  };

  return (
    <div className="container">
      <div className="admin-header-fullwidth">
        <div className="admin-header-content">
          <div className="admin-header-left">
            <img src="/logo.svg" alt="Project 31 Logo" className="admin-logo" />
          
          </div>
          
          <div className="admin-nav">
            <a href="/admin/dashboard">Dashboard</a>
            <a href="/admin/transactions">Transactions</a>
            <a href="/admin/manage-accounts">Accounts</a>
            <a href="/admin/bitcoins">Bitcoins</a>
          </div>
        </div>
      </div>

      <div className="dashboard-content admin-dashboard-content">
        <div className="admin-tools-section">
          <h2>Admin Tools</h2>
          <div className="admin-tools-grid">
            {adminTools.map((tool) => (
              <button
                key={tool.id}
                className="admin-tool-button"
                onClick={() => navigate(tool.path)}
              >
                {tool.title}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="admin-footer">
        <button onClick={handleLogout} className="admin-logout-button">
          Logout
        </button>
      </div>
    </div>
  );
};

export default AdminDashboardScreen;
